import { useEffect, useState } from "react"
import { countries } from "../../utils/countryData"

export default function PriorityForm({
  onCancel,
  onSave,
  initialValues
}: {
  onCancel: () => void
  onSave: (data: any) => void
  initialValues?: Record<string, any>
}) {
  const [office, setOffice] = useState("")
  const [filingNumber, setFilingNumber] = useState("")
  const [filingDate, setFilingDate] = useState("")
  const [errors, setErrors] = useState<{
    office?: boolean
    filingNumber?: boolean
    filingDate?: boolean
  }>({})

  useEffect(() => {
    setOffice(initialValues?.office || "")
    setFilingNumber(initialValues?.filingNumber || "")
    setFilingDate(
      initialValues?.filingDate
        ? String(initialValues.filingDate).slice(0, 10)
        : ""
    )
    setErrors({})
  }, [initialValues])

  const handleSubmit = () => {
    const newErrors: typeof errors = {}

    if (!office.trim()) newErrors.office = true
    if (!filingNumber.trim()) newErrors.filingNumber = true
    if (!filingDate) newErrors.filingDate = true

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    onSave({
      ...initialValues,
      office: office.trim(),
      filingNumber: filingNumber.trim(),
      filingDate
    })
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-1">
        <label className="text-sm font-medium text-gray-700">
          Country of the first filing *
        </label>
        <select
          value={office}
          onChange={(e) => {
            setOffice(e.target.value)
            setErrors((prev) => ({ ...prev, office: false }))
          }}
          className={`w-full rounded-md border px-3 py-2 text-sm transition focus:border-dantzBlue focus:ring-1 focus:ring-dantzBlue ${
            errors.office ? "border-red-500 bg-white" : "border-gray-300 bg-white"
          }`}
        >
          <option value="">- Select -</option>
          {countries.map((country) => (
            <option key={country} value={country}>
              {country}
            </option>
          ))}
        </select>
        {errors.office && (
          <span className="text-xs text-red-600">This field is required</span>
        )}
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        <div className="flex flex-col gap-1">
          <label className="text-sm font-medium text-gray-700">
            Filing date *
          </label>
          <input
            type="date"
            value={filingDate}
            onChange={(e) => {
              setFilingDate(e.target.value)
              setErrors((prev) => ({ ...prev, filingDate: false }))
            }}
            className={`w-full rounded-md border px-3 py-2 text-sm transition focus:border-dantzBlue focus:ring-1 focus:ring-dantzBlue ${
              errors.filingDate ? "border-red-500 bg-white" : "border-gray-300 bg-white"
            }`}
          />
          {errors.filingDate && (
            <span className="text-xs text-red-600">This field is required</span>
          )}
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-sm font-medium text-gray-700">
            Filing number *
          </label>
          <input
            type="text"
            value={filingNumber}
            onChange={(e) => {
              setFilingNumber(e.target.value)
              setErrors((prev) => ({ ...prev, filingNumber: false }))
            }}
            className={`w-full rounded-md border px-3 py-2 text-sm transition focus:border-dantzBlue focus:ring-1 focus:ring-dantzBlue ${
              errors.filingNumber ? "border-red-500 bg-white" : "border-gray-300 bg-white"
            }`}
          />
          {errors.filingNumber && (
            <span className="text-xs text-red-600">This field is required</span>
          )}
        </div>
      </div>

      <div className="flex flex-wrap gap-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm border border-gray-300 rounded-lg bg-white text-gray-700 transition hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleSubmit}
          className="px-4 py-2 text-sm rounded-lg font-medium text-white bg-dantzBlue transition hover:bg-blue-700"
        >
          Save
        </button>
      </div>
    </div>
  )
}
